import { inject } from '@angular/core';
import { Router, Routes, type UrlTree } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { NotFoundComponent } from '@shared/pages/not-found/not-found.component';
import publicRoutes from './components/public/public.routes';

/**
 * Puerta de las rutas privadas.
 *
 * Devuelve el **UrlTree de /login** en vez de `false`. Con `false` la ruta no
 * "matchea", el router sigue bajando y termina en el comodín `**`: sin sesión,
 * cualquier URL de la aplicación pintaba la **página 404**. Es lo que veía quien
 * se quedaba sin sesión con la pestaña abierta — "el sistema me saca" y aparece
 * una página de error que no explica nada ni ofrece volver a entrar.
 *
 * Basta con que HAYA token: si está caducado, el interceptor lo refresca en la
 * primera petición y la sesión sigue. Solo cuando ya no hay ninguno —porque el
 * refresco falló y se limpió— se manda al login.
 */
const requireSession = (): true | UrlTree => {
	if (inject(AuthService).getToken()) return true;
	return inject(Router).parseUrl('/login');
};

export const routes: Routes = [
	{
		path: '',
		children: publicRoutes,
	},
	// External portals (Kairos Merit): provisioned candidate / company accounts.
	{
		path: 'candidate',
		canMatch: [requireSession],
		loadChildren: () => import('./components/portal/candidate.routes'),
	},
	{
		path: 'company',
		canMatch: [requireSession],
		loadChildren: () => import('./components/portal/company.routes'),
	},
	{
		path: '',
		canMatch: [requireSession],
		loadChildren: () => import('./components/backoffice/backoffice.routes'),
	},
	{
		path: 'account',
		canMatch: [requireSession],
		loadChildren: () => import('./components/backoffice/account/account.routes'),
	},
	{
		path: '**',
		component: NotFoundComponent,
	},
];
